import { render, staticRenderFns } from "./product-offer-form.vue?vue&type=template&id=4c28aa56&scoped=true&"
import script from "./product-offer-form.vue?vue&type=script&lang=js&"
export * from "./product-offer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28aa56",
  null
  
)

export default component.exports